import { render } from "./InstructionsTable.vue?vue&type=template&id=1d719afc&scoped=true"
import script from "./InstructionsTable.vue?vue&type=script&lang=js"
export * from "./InstructionsTable.vue?vue&type=script&lang=js"

import "./InstructionsTable.vue?vue&type=style&index=0&id=1d719afc&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d719afc"]])

export default __exports__